import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  setHeaderTitle,
  resetHeaderTitle,
  setHeaderTitleDisabled,
} from 'app/shared-components/store/headerSlice';

const useHeaderTitle = (title, isDisabled = false) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (title) dispatch(setHeaderTitle(title));
    dispatch(setHeaderTitleDisabled(isDisabled));
    return () => dispatch(resetHeaderTitle());
  }, [dispatch, title, isDisabled]);
};

export default useHeaderTitle;
